<p-toast></p-toast>

<h2 class="page-title">
  {{ "i18n.domain.category.overview.title" | translate }}
</h2>

<div class="data-table">
  <p-toolbar>
    <ng-template pTemplate="left">
      <p-button
        label="{{ 'i18n.domain.category.overview.add' | translate }}"
        icon="pi pi-plus"
        (onClick)="openNew()"
      ></p-button>
    </ng-template>
    <ng-template pTemplate="right">
      <app-search-field
        (searchTextChanged)="onSearchTextChanged($event)"
      ></app-search-field>
    </ng-template>
  </p-toolbar>

  <p-table
    [value]="data"
    [rows]="pagedQuery.pageSize"
    [paginator]="true"
    [globalFilterFields]="globalFilters"
    [rowHover]="true"
    dataKey="categoryId"
    [lazy]="true"
    (onFilter)="onFilter($event)"
    (onPage)="onPageChange($event)"
    (onSort)="onSort($event)"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Categories"
    [showCurrentPageReport]="true"
    [totalRecords]="totalNoOfRecords"
    [rowsPerPageOptions]="pagedQuery.getPageSizes()"
    [filterDelay]="0"
    [filters]="columnFilters"
    styleClass="dt-grid"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          {{ "i18n.domain.category.fields.name" | translate }}
          <p-sortIcon field="name"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="name"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-category>
      <tr>
        <td>{{ category.name }}</td>
        <td>
          <div class="grid-commands">
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              [outlined]="true"
              severity="success"
              (onClick)="editItem(category)"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [rounded]="true"
              [outlined]="true"
              (onClick)="deleteCategory(category)"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="2">
          {{ "i18n.domain.category.overview.no-records" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [(visible)]="itemDialog"
    [style]="{ width: '450px' }"
    [modal]="true"
    styleClass="p-fluid"
  >
    <ng-template pTemplate="header">
      <div class="dialog-header">
        <span class="dialog-title">
          {{ "i18n.domain.category.overview.edit-dialog-title" | translate }}
        </span>
      </div>
    </ng-template>

    <!-- CONTENT -->
    <ng-template pTemplate="content">
      <form [formGroup]="form">
        <div class="field">
          <label for="name" class="control-label required">
            {{ "i18n.domain.category.fields.name" | translate }}
          </label>
          <input
            id="name"
            type="text"
            pInputText
            formControlName="name"
            placeholder="{{ 'i18n.domain.category.fields.name' | translate }}"
          />
          <app-error-messages
            [control]="form.controls.name"
          ></app-error-messages>
        </div>
      </form>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-button
        label="{{ 'i18n.shared.cancel' | translate }}"
        icon="pi pi-times"
        [text]="true"
        (onClick)="hideDialog()"
      ></p-button>

      <p-button
        label="{{ 'i18n.shared.save' | translate }}"
        icon="pi pi-check"
        [text]="true"
        (onClick)="saveCategory()"
        [disabled]="!form.valid"
      ></p-button>
    </ng-template>
  </p-dialog>
</div>
